/**
 * Textos (`ca`) de la secció «Articles» de la fitxa del proveïdor (OBR-186): què li comprem. Tall propi: no es
 * toca `ca.ts`. Les tres llengües han de tenir les mateixes claus (i18n.test.ts); cap text literal a les vistes.
 */

export const supplierArticlesCa = {
  'backoffice.supplierArticles': {
    // Secció del diàleg del proveïdor.
    sectionTitle: 'Articles',
    sectionHint:
      'Què li comprem: els articles vinculats a aquest proveïdor, amb la seva referència, la unitat de compra i el preu. Només es llegeix; els vincles s’editen des de la fitxa de l’article o amb l’importador d’article-proveïdor.',
    sectionNewHint: 'Els articles que li comprem es veuran aquí un cop hagis desat el proveïdor.',
    loadError: 'No s’han pogut carregar els articles d’aquest proveïdor.',
    empty: 'Encara no hi ha cap article vinculat a aquest proveïdor.',
    emptyFiltered: 'Cap article coincideix amb la cerca i els filtres.',

    // Cerca i filtres.
    searchLabel: 'Cerca per codi, nom o referència',
    filterStatus: 'Estat de l’article',
    statusActive: 'Només actius',
    statusAll: 'Tots (actius i de baixa)',
    statusInactive: 'Només de baixa',
    filterDefault: 'Proveïdor per defecte',
    defaultAll: 'Tots',
    defaultYes: 'Només els que té per defecte',
    defaultNo: 'Només els que no té per defecte',
    filterUnit: 'Unitat de compra',
    unitAll: 'Totes',
    unitBulk: 'A granel (unitat base)',

    // Recompte sota els filtres.
    summary_one: '{{count}} article',
    summary_other: '{{count}} articles',
    summaryOf_one: '{{shown}} de {{count}} article',
    summaryOf_other: '{{shown}} de {{count}} articles',
    hiddenInactive_one: '{{count}} article de baixa amagat',
    hiddenInactive_other: '{{count}} articles de baixa amagats',

    // Columnes de la llista.
    colCode: 'Codi',
    colArticle: 'Article',
    colRef: 'Referència del proveïdor',
    colUnit: 'Unitat de compra',
    colPrice: 'Preu de compra',
    colDefault: 'Per defecte',
    colStatus: 'Estat',

    // Cel·les.
    badgeDefault: 'Per defecte',
    badgeActive: 'Actiu',
    badgeInactive: 'Baixa',
    articleUnavailable: 'Article no disponible',
    unitUnavailable: 'Unitat no disponible',
    formatEquivalence: '1 {{unit}} = {{quantity}} {{base}}',
    formatBulk: 'A granel',
    pricePerUnit: '{{price}} €/{{unit}}',
    priceNoUnit: '{{price}} €',
    openArticleHint: 'Obre la fitxa de «{{name}}» en una pestanya nova',

    // Exportació a Excel.
    exportExcel: 'Exporta a Excel',
    exportBusy: 'Generant l’Excel…',
    exportError: 'No s’ha pogut generar l’Excel. Torna-ho a provar.',
    exportHint:
      'L’Excel porta els articles tal com es veuen ara, amb la cerca i els filtres aplicats.',
    excelSheetName: 'Articles',
    excelFileName: 'articles-{{supplier}}.xlsx',
    excelFileFallback: 'proveidor',
    excelColCode: 'Codi article',
    excelColName: 'Article',
    excelColRef: 'Referència del proveïdor',
    excelColDescription: 'Descripció del proveïdor',
    excelColUnit: 'Unitat de compra',
    excelColFormat: 'Equivalència',
    excelColPrice: 'Preu de compra (per unitat base)',
    excelColBaseUnit: 'Unitat base',
    excelColDefault: 'Proveïdor per defecte',
    excelColStatus: 'Estat de l’article',
    excelYes: 'Sí',
    excelNo: 'No',
  },
} as const;
